var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"select-6 flex-vh-center"},[_c('span',{staticClass:"bottom-words",on:{"click":_vm.tolink}},[_vm._v("浙ICP备2023010978号-1 杭州逢石科技有限公司")])])}
var staticRenderFns = []

export { render, staticRenderFns }